module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8FwSk"))).then(() => parcelRequire('1iHdE'));